import "../../Home/styles/ImageRotationAnimation.css";
import { useImageRotationAnimation } from "../hooks/useImageRotationAnimation";
import logoUrl from "../../../assets/images/logo.png"

function ImageRotationAnimation({ images}) {
  const {
    bannerRef,
    behindLayerRef,
    frontLayerRef,
    wrapsRef,
    cardsRef,
    animationImages,
  } = useImageRotationAnimation({ images});

  if (!animationImages || animationImages.length < 4) return null;

  return (
    <div
      ref={bannerRef}
      className="image-rotation-banner"
      style={{
        position: "relative",
        height: "clamp(400px, 70vh, 70vh)",
        minHeight: "clamp(350px, 50vh, 520px)",
        overflow: "visible",
        margin: "0 5vw 2rem 5vw",
        paddingTop: "1rem",
      }}
    >
      {/* Behind Layer */}
      <div
        ref={behindLayerRef}
        style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 4 }}
      />

      {/* Text */}
      <h1 className="display-1 bold image-rotation-title">obsessions</h1>

      {/* Logo */}
      {logoUrl && (
        <img
          src={logoUrl}
          alt="Logo"
          className="img-left-logo"
        />
      )}

      {/* Front Layer */}
      <div
        ref={frontLayerRef}
        style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 8 }}
      >
        {animationImages.map((img, index) => (
          <div
            key={index}
            ref={(el) => (wrapsRef.current[index] = el)}
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              willChange: "transform",
            }}
          >
            <div
              ref={(el) => (cardsRef.current[index] = el)}
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                transform: "translate(-50%, -50%)",
                width:
                  window.innerWidth <= 768
                    ? "150px"  // Increased for better quality with scale
                    : window.innerWidth <= 1024
                      ? "220px"
                      : window.innerWidth <= 1440
                        ? "230px"
                        : "230px",
                aspectRatio: "1 / 1",
                padding:
                  window.innerWidth <= 768
                    ? "6px"
                    : window.innerWidth <= 1024
                      ? "8px"
                      : "12px",
                boxSizing: "border-box",
                transformOrigin: "50% 50%",
                willChange: "transform, opacity",
              }}
            >
              <img
                src={img.src}
                alt={img.alt}
                style={{
                  width: "100%",
                  height: "100%",
                  display: "block",
                  objectFit: "contain",
                  objectPosition: "center",
                  transform: "translateZ(0)",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ImageRotationAnimation;
